import React from 'react';
import useChatModel from '@whelk/hooks/src/useChatModel';

const ModelLabel = () => {
  const { modelName, ModelIcon, model } = useChatModel();
  return (
    <div className='flex items-center gap-2'>
      <img
        src={ModelIcon}
        alt={`model-${model}`}
        className='h-[14px] w-[14px] rounded object-cover'
      />
      <span className=' text-[15px]'>{modelName}</span>
    </div>
  );
};

export default ModelLabel;
